export default __webpack_public_path__ + "./images/litres.2ced9133.svg";